/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from "@src/app/app.module";
import { ChatField } from "@src/app/shared/chat/chat-field";
import { MatDialog } from "@angular/material/dialog";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { ServiceRequest } from "@src/app/model/serviceRequest";
import { of } from "rxjs";
import { concatMap } from "rxjs/operators";
import { ChatUpsertComponent } from "@src/app/shared/chat/chat-upsert/chat-upsert.component";
import { AbstractHttpService } from "@src/app/shared/abstract-http.service";

export class AddCommentAction implements IFormAction {
    name = $localize`Message to Followers`;
    color: ActionColor = 'primary';
    show = true;
    icon = 'reply';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText: string;
    sr: ServiceRequest;

    constructor(
        private chatField: ChatField, private dataSvc: AbstractHttpService
    ) {}

    action() {
        console.log('Take Actions');
        const dialog = MyInjector.instance.get(MatDialog);
        const dialogRef = dialog.open(ChatUpsertComponent,
            {
                data:
                {
                    chatField: this.chatField,
                }
            }
        );

        return dialogRef.afterClosed().pipe( concatMap(newComment => {
            /* If showing comments in a pop up modal, with zero comments
            and no comment was added, better close the comments modal...
            */
            if (newComment) {
                return this.dataSvc.getOne(this.sr.id, null, this.sr.teamId);
            } else {
                return of(this.sr);
            }
        }));
    }

    //  setup(serviceRequest: ServiceRequest) {
    setup(sr: ServiceRequest) {
        this.sr = sr;
        this.show = true;
    }
}